export default __webpack_public_path__ + "static/media/eye.e46d0481.svg";